const subscriberScope = {
  name: 'Subscriber scope',
  permission: 'variables'
};

export default subscriberScope;
